/**
 * Move animals into a field.
 *
 * This helper function is separated from UpdateBiomassAfterMoveInDialog.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

import { QueryClient } from "@tanstack/react-query";
import { AnalyticsEvents, analytics } from "common/analytics";
import { queryClient } from "common/queryClient";
import { moveIntoField } from "services";

export async function moveAnimalsIn(
  newFieldWithAnimals: { guid: string; name: string },
  currentFieldWithAnimals: { guid: string } | undefined,
  dateTimeIn: Date,
  qc: QueryClient = queryClient
) {
  await moveIntoField(
    newFieldWithAnimals.guid,
    currentFieldWithAnimals?.guid,
    dateTimeIn,
    qc
  );
  analytics.track(AnalyticsEvents.ANIMAL_MOVE_COMPLETED);
}
